import { render, staticRenderFns } from "./CasinoTabs.vue?vue&type=template&id=56caf142&"
import script from "./CasinoTabs.vue?vue&type=script&lang=js&"
export * from "./CasinoTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports